// @ts-nocheck
/**
 * 上一次获取到的 script 地址
 */
let lastSrcs;

/**
 * 用于提取html字符串中的 script 标签上的 src
 */
const scriptReg = /<script.*?src=["'](?<src>[^"']+)/gm;

/**
 * 刷新间隔
 */
const DURATION = 2 * 60000;

async function extractNewScripts() {
    const html = await fetch(`./?_timestamp=${Date.now()}`).then((resp) => resp.text());
    scriptReg.lastIndex = 0;

    let result = [];
    let match;
    while ((match = scriptReg.exec(html))) {
        result.push(match.groups.src);
    }
    return result;
}

async function needUpdate() {
    const newScripts = await extractNewScripts();
    if (!lastSrcs) {
        lastSrcs = newScripts;
        return false;
    }
    let result = false;
    if (lastSrcs.length !== newScripts.length) {
        result = true;
    }
    for (let i = 0, length = lastSrcs.length; i < length; i++) {
        if (lastSrcs[i] !== newScripts[i]) {
            result = true;
            break;
        }
    }
    lastSrcs = newScripts;
    return result;
}

function autoRefresh() {
    setTimeout(async () => {
        const willUpdate = await needUpdate();
        if (willUpdate) {
            const result = confirm('页面有更新，点击刷新页面');
            if (result) {
                setTimeout(() => {
                    location.reload(true);
                }, 300);
            }
        }
        autoRefresh();
    }, DURATION);
}

if (import.meta.env.MODE !== 'development') {
    autoRefresh();
}
